import { get, post, deleteRequest, patch } from 'utils/api';

export const getCoCapexData = (data) =>{
    return get('/coCapexBrands', data)
}

export const addCoCapexData = (data) =>{
    return post('/coCapexBrands', data)
}
export const deleteCoCapexItem = (id) =>{
    return deleteRequest(`/coCapexBrands?id=${id}`, )
}
export const updateCoCapexItem = (data) =>{
    return patch('/coCapexBrands', data)
}

export const coCapexData = {
    getCoCapexData,
    addCoCapexData,
    deleteCoCapexItem,
    updateCoCapexItem,
}